import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@components/AppProvider';
import { useResolvedTheme } from '@hooks/useResolvedTheme';
import { joomlaOptions } from '@services/joomla';
import { routerBasePath } from './routes';
import { UserShell } from './UserShell';

/**
 * Member composition root. Applies the member theme to the SPA mount node and
 * wraps the shell in the shared providers + a BrowserRouter whose basename is
 * the Joomla subfolder, so the member tabs become real SEF URLs that deep-link,
 * refresh and round-trip through the Joomla site router.
 */
export function SiteApp() {
  const theme = joomlaOptions().theme || 'paper';
  useResolvedTheme('rewardify-site', theme, 'site');

  return (
    <AppProvider>
      <BrowserRouter basename={routerBasePath()}>
        <UserShell />
      </BrowserRouter>
    </AppProvider>
  );
}
